export default "__VITE_ASSET__C4KyW1VC__"